var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"mr-4",attrs:{"to":"/"}},[_c('div',{staticClass:"title white--text",attrs:{"id":"panel-brand"}},[_vm._v(" E-Commerge "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Panel")])])])}
var staticRenderFns = []

export { render, staticRenderFns }